export type HeaderProspectsOptionInterface = {
    id: number;
    label: string;
    col: number;
    md_col?: number;
};

export const HeaderProspectsOption: HeaderProspectsOptionInterface[] = [
    {
        id: 1,
        label: 'Costumer Service',
        col: 4,
        md_col: 3,
    },
    {
        id: 2,
        label: 'Datos del usuario',
        col: 4,
        md_col: 3,
    },
    // {
    //     id: 3,
    //     label: 'Información del usuario',
    //     col: 3,
    // },
    {
        id: 4,
        label: 'Notas',
        col: 4,
        md_col: 2,
    },
];
